(() => {
  const ready = (fn) => document.readyState === 'loading' ? document.addEventListener('DOMContentLoaded', fn) : fn();
  const reduceMotion = () => window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  ready(() => {
    /* Header state */
    const header = document.querySelector('.rayaal-header');
    const syncHeader = () => header?.classList.toggle('is-scrolled', window.scrollY > 20);
    syncHeader();
    window.addEventListener('scroll', syncHeader, { passive: true });

    /* Accessible mobile menu */
    const menu = document.querySelector('[data-rayaal-mobile-menu]');
    const openButton = document.querySelector('[data-rayaal-menu-open]');
    const closeButton = document.querySelector('[data-rayaal-menu-close]');
    let menuOpen = false;
    let restoreFocus = null;
    const focusables = () => [...(menu?.querySelectorAll('a[href],button:not([disabled]),input:not([disabled]),select:not([disabled]),textarea:not([disabled]),[tabindex]:not([tabindex="-1"])') || [])];
    const setMenu = (open) => {
      if (!menu) return;
      menuOpen = open;
      if (open) restoreFocus = document.activeElement;
      menu.classList.toggle('is-open', open);
      menu.setAttribute('aria-hidden', open ? 'false' : 'true');
      openButton?.setAttribute('aria-expanded', open ? 'true' : 'false');
      document.documentElement.style.overflow = open ? 'hidden' : '';
      if (open) requestAnimationFrame(() => closeButton?.focus());
      else restoreFocus?.focus?.();
    };
    openButton?.addEventListener('click', () => setMenu(true));
    closeButton?.addEventListener('click', () => setMenu(false));
    menu?.querySelectorAll('a').forEach((link) => link.addEventListener('click', () => setMenu(false)));
    document.addEventListener('keydown', (event) => {
      if (!menuOpen) return;
      if (event.key === 'Escape') { event.preventDefault(); setMenu(false); return; }
      if (event.key !== 'Tab') return;
      const items = focusables();
      if (!items.length) return;
      const first = items[0];
      const last = items[items.length - 1];
      if (event.shiftKey && document.activeElement === first) { event.preventDefault(); last.focus(); }
      else if (!event.shiftKey && document.activeElement === last) { event.preventDefault(); first.focus(); }
    });

    /* Reveal */
    if ('IntersectionObserver' in window && !reduceMotion()) {
      const observer = new IntersectionObserver((entries) => entries.forEach((entry) => {
        if (entry.isIntersecting) { entry.target.classList.add('is-visible'); observer.unobserve(entry.target); }
      }), { threshold: 0.1, rootMargin: '0px 0px -4% 0px' });
      document.querySelectorAll('[data-rayaal-reveal]').forEach((el) => observer.observe(el));
    } else {
      document.querySelectorAll('[data-rayaal-reveal]').forEach((el) => el.classList.add('is-visible'));
    }

    /* Hero pointer light + parallax */
    const hero = document.querySelector('.rayaal-hero');
    if (hero && !reduceMotion()) {
      hero.addEventListener('pointermove', (event) => {
        const rect = hero.getBoundingClientRect();
        hero.style.setProperty('--rayaal-mx', `${((event.clientX - rect.left) / rect.width) * 100}%`);
        hero.style.setProperty('--rayaal-my', `${((event.clientY - rect.top) / rect.height) * 100}%`);
      }, { passive: true });
      hero.addEventListener('pointerleave', () => {
        hero.style.removeProperty('--rayaal-mx');
        hero.style.removeProperty('--rayaal-my');
      });
    }

    const parallaxItems = [...document.querySelectorAll('[data-rayaal-parallax]')];
    if (!reduceMotion() && parallaxItems.length) {
      let ticking = false;
      const update = () => {
        const h = window.innerHeight;
        parallaxItems.forEach((el) => {
          const rect = el.getBoundingClientRect();
          const progress = (rect.top + rect.height / 2 - h / 2) / h;
          const speed = Number(el.dataset.rayaalParallax || 18);
          el.style.transform = `translate3d(0, ${progress * speed}px, 0) scale(1.04)`;
        });
        ticking = false;
      };
      window.addEventListener('scroll', () => { if (!ticking) { requestAnimationFrame(update); ticking = true; } }, { passive: true });
      update();
    }

    /* Mobile sticky Add to Cart mirrors native state */
    const mobileBar = document.querySelector('[data-rayaal-mobile-buybar]');
    const mobileAdd = mobileBar?.querySelector('[data-rayaal-mobile-add]');
    const nativeAdd = document.querySelector('product-info .product-form__submit');
    if (mobileBar && mobileAdd && nativeAdd) {
      const syncAddState = () => {
        mobileAdd.disabled = nativeAdd.disabled || nativeAdd.getAttribute('aria-disabled') === 'true';
        const label = nativeAdd.querySelector('span')?.textContent?.trim();
        mobileAdd.textContent = label || 'Add to cart';
      };
      syncAddState();
      new MutationObserver(syncAddState).observe(nativeAdd, { attributes: true, childList: true, subtree: true });
      mobileAdd.addEventListener('click', () => nativeAdd.click());
      if ('IntersectionObserver' in window) {
        const buyObserver = new IntersectionObserver(([entry]) => mobileBar.classList.toggle('is-visible', !entry.isIntersecting), { threshold: 0.05 });
        buyObserver.observe(nativeAdd);
      }
    }
  });
})();
